import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BasicEventPlayer} from "../../../entities/auth/BasicEventPlayer";
import {AuthService} from "../../../services/AuthService";
import {APIService} from "../../../services/APIService";
import {EventRank} from "../../../entities/auth/EventRank";

@Component({
  selector: 'app-rank-dialogue',
  templateUrl: './rank-dialogue.component.html',
  styleUrls: ['./rank-dialogue.component.css']
})
export class RankDialogueComponent {
  rankGroup;

  rankControl = new FormControl();

  ranks: EventRank[] = []

  constructor(private _formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<RankDialogueComponent>,
              private auth: AuthService,
              private api: APIService,
              @Inject(MAT_DIALOG_DATA) public player: BasicEventPlayer) {
    this.rankControl = new FormControl(player.ranks)

    this.rankGroup = _formBuilder.group({
      firstCtrl: [player.ranks.map((r) => r.id), Validators.required]
    })

    this.api.getRanks().then((a) => this.ranks = a);
  }

  save() {
    this.dialogRef.close({rank: this.rankGroup.value.firstCtrl})
  }
}
